

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};

window.addEventListener("load", function () {
     $(".MS__sprite-btn-closefloatright").on("click", function (e) {
        e.stopPropagation(); // Ngăn event bubbling
        $(".floatright__main").toggleClass("active")
        $(".close_floatright").toggleClass("active")
    })
});
